import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../shared/ui/Spinner/Spinner";
import { Box, Typography } from "@mui/material";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/"); // Redirect to home after 5 seconds
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
    >
      <Typography variant="h3" color="error" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Spinner message="Redirecting you to the home page..." color="error" />
    </Box>
  );
};

export default NotFound;
